import React, { useState } from 'react';
export const Spotlight = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    organization: '',
    socialMedia: '',
    bio: '',
    mission: '',
    inspiration: '',
    problem: '',
    impact: '',
    experience: '',
    moment: '',
    collaborations: '',
    influences: '',
    advice: '',
    photoLinks: '',
    logoLink: '',
    consent: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage('');
    try {
      // Prepare data for Google Sheet
      const submissionData = {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        location: formData.location,
        role: formData.role,
        organization: formData.organization,
        socialMedia: formData.socialMedia,
        bio: formData.bio,
        mission: formData.mission,
        inspiration: formData.inspiration,
        problem: formData.problem,
        impact: formData.impact,
        experience: formData.experience,
        moment: formData.moment,
        collaborations: formData.collaborations,
        influences: formData.influences,
        advice: formData.advice,
        photoLinks: formData.photoLinks,
        logoLink: formData.logoLink,
        consent: formData.consent,
        submittedAt: new Date().toISOString()
      };
      console.log('Submitting form to Google Sheet...');
      const response = await fetch('https://script.google.com/macros/s/AKfycbx5J7CRh1JX7_9E-LHEQNz17oj77yzni2E8uTjT8uZ6qpjMnvQo_uS6ZdAE-dVLw6YeGw/exec', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(submissionData)
      });
      // With no-cors mode, we can't read the response, but if no error was thrown, assume success
      console.log('Form submitted successfully');
      setIsSubmitted(true);
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        location: '',
        role: '',
        organization: '',
        socialMedia: '',
        bio: '',
        mission: '',
        inspiration: '',
        problem: '',
        impact: '',
        experience: '',
        moment: '',
        collaborations: '',
        influences: '',
        advice: '',
        photoLinks: '',
        logoLink: '',
        consent: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage('Network or server error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="pt-20 min-h-screen" data-id="element-4617" data-mp="ocamyx8zwocj">
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-4618" data-mp="t4akkj1lf55y">
        <div className="container mx-auto px-4" data-id="element-4619" data-mp="t6nd1q4z8xx9">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4620" data-mp="fdyragt9v0d8">
            <h1 className="text-4xl font-bold mb-6 text-gray-800" data-id="element-4621" data-mp="fbckije7gow2">
              ✨ The Salon Spotlight
            </h1>
            <p className="text-gray-600 mb-4" data-id="element-4622" data-mp="174le5tuaexut">
              We're shining the light on remarkable people shaping culture in
              their own unique ways — creators, thinkers, innovators, builders,
              and dreamers who are pushing boundaries and making impact.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-4623" data-mp="132hysu4hz949">
              This feature is part of The Networking Salon's ongoing effort to
              celebrate individuals who are moving ideas, communities, and
              culture forward.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-4624" data-mp="3nuk3s7l44bl3">
              Please fill in the details below to help us tell your story
              beautifully.
            </p>
            <p className="text-gray-600 font-medium" data-id="element-4625" data-mp="25zt40xsyz0z">
              Short, honest, and heartfelt responses are best.
            </p>
          </div>
        </div>
      </section>
      <section className="py-12" data-id="element-4626" data-mp="3pb7mhxux5a26">
        <div className="container mx-auto px-4" data-id="element-4627" data-mp="3pc0n0h3ab3bv">
          <div className="max-w-3xl mx-auto" data-id="element-4628" data-mp="3p94p2srfsenf">
            {isSubmitted ? <div className="text-center py-16 px-6 border-2 border-gray-300 rounded-lg" data-id="element-4629" data-mp="pusuwe13w13i">
                <h2 className="text-2xl font-bold mb-4 text-gray-800" data-id="element-4630" data-mp="ky2h5xcrxhl9">
                  Thank you for sharing your story with us!
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-4631" data-mp="gx8o6pkh5cli">
                  Our team will review your submission and reach out when your
                  feature is scheduled.
                </p>
                <p className="text-gray-600 font-medium" data-id="element-4632" data-mp="31jk464bq37bi">
                  Keep creating, building, and shaping the culture — the world
                  needs what you bring. 💫
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-10" data-id="element-4633" data-mp="1c2oi24jlcjho">
                {errorMessage && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md" data-id="element-4634" data-mp="1h1hya4q9iolj">
                    <p className="font-medium" data-id="element-4635" data-mp="1l3381h7i2mri">Error submitting form:</p>
                    <p data-id="element-4636" data-mp="1pxh5dp5q33yt">{errorMessage}</p>
                  </div>}
                {/* SECTION 1: Personal Details */}
                <div className="space-y-6" data-id="element-4637" data-mp="1uuqzhi4243sz">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4638" data-mp="1ztkg3jen4axd">
                    SECTION 1: Personal Details
                  </h2>
                  <div className="space-y-4" data-id="element-4639" data-mp="24rc9khuxo53o">
                    <div data-id="element-4640" data-mp="28tqq2vb4qsrs">
                      <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-4641" data-mp="28tz5atuq6a65">
                        Full Name *
                      </label>
                      <input type="text" id="fullName" name="fullName" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4642" data-mp="efzazga17goy" />
                    </div>
                    <div data-id="element-4643" data-mp="1cueiahsc9o9f">
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-4644" data-mp="1qscvvkyu5gnv">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4645" data-mp="1mp6k5xsyexa0" />
                    </div>
                    <div data-id="element-4646" data-mp="2agc87091svve">
                      <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-4647" data-mp="2agu41vrst82s">
                        Phone Number (WhatsApp Preferred) *
                      </label>
                      <input type="tel" id="phone" name="phone" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4648" data-mp="2jgquo2xr0h0h" />
                    </div>
                    <div data-id="element-4649" data-mp="2y4qxk3hj9zxg">
                      <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-4650" data-mp="2y4ihk2q46ei1">
                        City / Country *
                      </label>
                      <input type="text" id="location" name="location" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4651" data-mp="2p1zjdvx9wq24" />
                    </div>
                    <div data-id="element-4652" data-mp="2fb4u0ioqdacg">
                      <label htmlFor="role" className="block text-gray-700 font-medium mb-1" data-id="element-4653" data-mp="2k3o7zgrby7hs">
                        Role / Profession / Creative Focus *
                      </label>
                      <input type="text" id="role" name="role" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4654" data-mp="25d78i2y99rnj" />
                    </div>
                    <div data-id="element-4655" data-mp="21dydyvve5pqx">
                      <label htmlFor="organization" className="block text-gray-700 font-medium mb-1" data-id="element-4656" data-mp="21c57phoox7jg">
                        Organization, Brand, or Project Name
                      </label>
                      <input type="text" id="organization" name="organization" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" onChange={handleChange} data-id="element-4657" data-mp="2bxemekyqervq" />
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4658" data-mp="22v5fs66l3inm">Optional</p>
                    </div>
                    <div data-id="element-4659" data-mp="1xy6nzuae7nsl">
                      <label htmlFor="socialMedia" className="block text-gray-700 font-medium mb-1" data-id="element-4660" data-mp="1xyf0vm6imt3s">
                        Social Media Links (Please include any that apply)
                      </label>
                      <textarea id="socialMedia" name="socialMedia" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={5} placeholder="LinkedIn:
Instagram:
X (Twitter):
Website / Portfolio:" onChange={handleChange} data-id="element-4661" data-mp="1o4fzwqi6hfdf"></textarea>
                    </div>
                    <div data-id="element-4662" data-mp="3lumw0d1k1eu5">
                      <label htmlFor="bio" className="block text-gray-700 font-medium mb-1" data-id="element-4663" data-mp="3lv65r6h1wwx3">
                        Short Bio (3–5 lines) *
                      </label>
                      <textarea id="bio" name="bio" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4664" data-mp="3uvaycahl5qr7"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 2: Your Story */}
                <div className="space-y-6" data-id="element-4665" data-mp="374p53pc8qb19">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4666" data-mp="373dzdjz8it7i">
                    SECTION 2: Your Story
                  </h2>
                  <div className="space-y-4" data-id="element-4667" data-mp="3gwbj1tfyqo7p">
                    <div data-id="element-4668" data-mp="3gx4moljmkxlm">
                      <label htmlFor="mission" className="block text-gray-700 font-medium mb-1" data-id="element-4669" data-mp="2jgfn6yi5e7fe">
                        Tell us about what you do. What's your mission or
                        creative focus? *
                      </label>
                      <textarea id="mission" name="mission" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4670" data-mp="6zi6s9fah8qy"></textarea>
                    </div>
                    <div data-id="element-4671" data-mp="kzkj7g4tv9yt">
                      <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-4672" data-mp="kyrjgz4adkq6">
                        What inspired you to start this journey? *
                      </label>
                      <textarea id="inspiration" name="inspiration" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4673" data-mp="3ohkub45ojvgn"></textarea>
                    </div>
                    <div data-id="element-4674" data-mp="22rpxjvnu94h">
                      <label htmlFor="problem" className="block text-gray-700 font-medium mb-1" data-id="element-4675" data-mp="30rgrgz0bfzqp">
                        What problem are you trying to solve — or what change
                        are you hoping to make?
                      </label>
                      <textarea id="problem" name="problem" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4676" data-mp="2y5r5owaedq69"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4677" data-mp="2oafpsan96cwx">Optional</p>
                    </div>
                  </div>
                </div>
                {/* SECTION 3: Culture & Impact */}
                <div className="space-y-6" data-id="element-4678" data-mp="2f9rdbkdickm5">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4679" data-mp="2agofh01p6p05">
                    SECTION 3: Culture & Impact
                  </h2>
                  <div className="space-y-4" data-id="element-4680" data-mp="20is6oew8g657">
                    <div data-id="element-4681" data-mp="20jtlmugddcs7">
                      <label htmlFor="impact" className="block text-gray-700 font-medium mb-1" data-id="element-4682" data-mp="20kldpvarcsdq">
                        How do you think your work contributes to shaping
                        culture or your community? *
                      </label>
                      <textarea id="impact" name="impact" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4683" data-mp="1gwp8s11u5s3u"></textarea>
                    </div>
                    <div data-id="element-4684" data-mp="17y4udc3b64lf">
                      <label htmlFor="experience" className="block text-gray-700 font-medium mb-1" data-id="element-4685" data-mp="1cvdgtovhoush">
                        What do you want people to feel or experience through
                        what you do?
                      </label>
                      <textarea id="experience" name="experience" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4686" data-mp="24lhznj3lp9rl"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4687" data-mp="1vsofp8d7lm7e">Optional</p>
                    </div>
                    <div data-id="element-4688" data-mp="2ji91dz0qyxkd">
                      <label htmlFor="moment" className="block text-gray-700 font-medium mb-1" data-id="element-4689" data-mp="2jhz55tp3zu68">
                        Share one moment that reminded you your work matters. *
                      </label>
                      <textarea id="moment" name="moment" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4690" data-mp="2tnqpyq7rsp2q"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 4: Connection & Inspiration */}
                <div className="space-y-6" data-id="element-4691" data-mp="2erj8vyrns3ro">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4692" data-mp="2esb1r1tvfne9">
                    SECTION 4: Connection & Inspiration
                  </h2>
                  <div className="space-y-4" data-id="element-4693" data-mp="2opz001qord16">
                    <div data-id="element-4694" data-mp="2jp1ilrdi2n0q">
                      <label htmlFor="collaborations" className="block text-gray-700 font-medium mb-1" data-id="element-4695" data-mp="2jot45v1qb9nf">
                        What kind of collaborations or opportunities are you
                        open to right now?
                      </label>
                      <textarea id="collaborations" name="collaborations" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4696" data-mp="24nm9pqot4l6n"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4697" data-mp="2elk7b4sk3ubx">Optional</p>
                    </div>
                    <div data-id="element-4698" data-mp="2innjxwqyp4ys">
                      <label htmlFor="influences" className="block text-gray-700 font-medium mb-1" data-id="element-4699" data-mp="2ioyo3xobkeqf">
                        Who or what influences your work the most? *
                      </label>
                      <textarea id="influences" name="influences" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4700" data-mp="2sk0cuseonesh"></textarea>
                    </div>
                    <div data-id="element-4701" data-mp="36d9ichzifg5q">
                      <label htmlFor="advice" className="block text-gray-700 font-medium mb-1" data-id="element-4702" data-mp="36dre7di9fsd4">
                        What advice would you give to other young people trying
                        to build something meaningful? *
                      </label>
                      <textarea id="advice" name="advice" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={4} onChange={handleChange} data-id="element-4703" data-mp="upmglm5nvqyb"></textarea>
                    </div>
                  </div>
                </div>
                {/* SECTION 5: Visuals */}
                <div className="space-y-6" data-id="element-4704" data-mp="1ifgsa0e8v9gz">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4705" data-mp="1iefkc4siz33h">
                    SECTION 5: Visuals
                  </h2>
                  <div className="space-y-4" data-id="element-4706" data-mp="19lvdih22xs7k">
                    <div data-id="element-4707" data-mp="19ksqwlbsibxg">
                      <label htmlFor="photoLinks" className="block text-gray-700 font-medium mb-1" data-id="element-4708" data-mp="14o26jlsycu68">
                        Links to 1–2 photos (portrait or action shots) *
                      </label>
                      <textarea id="photoLinks" name="photoLinks" required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" rows={3} placeholder="Paste Google Drive, Dropbox, or other image links here. One link per line." onChange={handleChange} data-id="element-4709" data-mp="1xby3mrmfoo3j"></textarea>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4710" data-mp="27h7rsqeit2rl">
                        Please provide publicly accessible links to your photos
                        (Google Drive, Dropbox, etc.)
                      </p>
                    </div>
                    <div data-id="element-4711" data-mp="1xkbiiigssclz">
                      <label htmlFor="logoLink" className="block text-gray-700 font-medium mb-1" data-id="element-4712" data-mp="22h1y74oox66v">
                        Optional: Link to your logo or brand image
                      </label>
                      <input type="url" id="logoLink" name="logoLink" className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" placeholder="https://example.com/your-logo.png" onChange={handleChange} data-id="element-4713" data-mp="1sivvwlyz1y1h" />
                      <p className="text-sm text-gray-500 mt-1" data-id="element-4714" data-mp="3mwn2fcm081sp">
                        Optional. Paste a link to your logo or brand image.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Final Consent */}
                <div className="space-y-6" data-id="element-4715" data-mp="1kzwbcczry0gj">
                  <h2 className="text-xl font-bold text-gray-800 border-b-2 border-gray-300 pb-2" data-id="element-4716" data-mp="1l1pkq01ruys8">
                    Final Consent
                  </h2>
                  <div data-id="element-4717" data-mp="1uwramy3vg4vv">
                    <p className="block text-gray-700 font-medium mb-2" data-id="element-4718" data-mp="1uw967e722kcv">
                      Do you give The Networking Salon permission to feature
                      your story, photos, and content (with credit) across its
                      digital platforms and media? *
                    </p>
                    <div className="space-y-2" data-id="element-4719" data-mp="1z0745lkn9p4c">
                      <label className="flex items-center" data-id="element-4720" data-mp="9jxx7upqoo8g">
                        <input type="radio" name="consent" value="Yes, I do" required className="mr-2 h-5 w-5" onChange={handleChange} data-id="element-4721" data-mp="9mk6bysa3bss" />
                        <span className="text-gray-700" data-id="element-4722" data-mp="3fvmf5ed3q1d7">Yes, I do</span>
                      </label>
                      <label className="flex items-center" data-id="element-4723" data-mp="3jw69yba7csw6">
                        <input type="radio" name="consent" value="I'd like to review my feature before it's published (T&C Apply)" className="mr-2 h-5 w-5" onChange={handleChange} data-id="element-4724" data-mp="3julfsmrsvbyu" />
                        <span className="text-gray-700" data-id="element-4725" data-mp="3tlpvjopav0uq">
                          I'd like to review my feature before it's published
                          (T&C Apply)
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                {/* Submit Button */}
                <div className="pt-4" data-id="element-4726" data-mp="3avqb5f4em9xn">
                  <button type="submit" disabled={isSubmitting} className="w-full py-3 px-6 bg-gray-800 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 disabled:opacity-70" data-id="element-4727" data-mp="3awt19ktwk8ci">
                    {isSubmitting ? 'Submitting...' : 'Submit Your Story'}
                  </button>
                </div>
              </form>}
          </div>
        </div>
      </section>
    </div>;
};